module.exports = __webpack_public_path__ + "img/tl-logo.eebc19e0.png";